import OnboardingSteps from './onboarding-steps'

export default OnboardingSteps
